<template>
  <div class="select-page">
    <div class="select-page__intro">
      <div class="texts">
        Окна большинства резиденций выходят на разные стороны света, чтобы
        обеспечить светлое и комфортное пространство. Все резиденции
        предлагаются с предчистовой отделкой White Box.
      </div>

      <div class="tabs-nav" v-if="!this.$mobView">
        <span
          :class="['_tab', viewType == 'list' ? 'active' : '']"
          @click="viewTypeChange('list')"
          >Выбор по параметрам</span
        >
        <span
          :class="['_tab', viewType == 'map' ? 'active' : '']"
          @click="viewTypeChange('map')"
          >Выбор по генплану</span
        >
        <span
          :class="['_tab', viewType == 'favorites' ? 'active' : '']"
          @click="viewTypeChange('favorites')"
          >Избранное</span
        >
      </div>
    </div>

    <div :class="['aparts-select-tool', 'aparts-select-tool--' + viewType]">
      <transition name="tab">
        <ApartsList v-if="viewType == 'list'" :key="viewType" />
        <ApartsList
          v-if="viewType == 'favorites'"
          :favorites="true"
          :key="viewType"
        />
        <ApartsMap v-else-if="viewType == 'map'" />
      </transition>
    </div>

    <div class="video-block">
      <video playsinline="" autoplay loop muted>
        <source src="video-about-2.mp4" />
      </video>
    </div>

    <div>
      <InteractForm :onlyForm="true" />
    </div>
  </div>
</template>

<script>
import ApartsList from "@/components/ApartsList"
import ApartsMap from "@/components/ApartsMap"
import InteractForm from "@/components/Interact.vue"

export default {
  name: "Aparts",
  data() {
    return {
      viewType: "list",
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    const hash = window.location.hash
    if (hash === "#fav") this.viewType = "favorites"
  },
  methods: {
    viewTypeChange(name) {
      this.viewType = name
    },
  },
  components: {
    ApartsList,
    ApartsMap,
    InteractForm,
  },
}
</script>
